import { render } from "./SwapItemModal.vue?vue&type=template&id=685daabb&scoped=true"
import script from "./SwapItemModal.vue?vue&type=script&lang=js"
export * from "./SwapItemModal.vue?vue&type=script&lang=js"

import "./SwapItemModal.vue?vue&type=style&index=0&id=685daabb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685daabb"]])

export default __exports__